import React from "react";
import Container from "./container";
import styled from "styled-components";

//Components
import ThemeHeader from "./components/themeHeader";
import ThemeMainContent from "./components/themeMainContent";
import ThemeFooter from "./components/themeFooter";

const ThemePreview = props => {
  return (
    <ThemePreviewContainer>
      <ThemeHeader {...props} />
      <ThemeMainContent {...props} />
      {!props.hideFooter && <ThemeFooter {...props} />}
    </ThemePreviewContainer>
  );
};

const ThemePreviewContainer = styled.div`
  padding-top: 30px;
  text-align: left;
`;

export default Container(ThemePreview);
